import React from 'react'
import dynamic from 'next/dynamic'
import { FacilityCategoriesTypes } from './Categories'

const Entertainment = dynamic(() => import('client/icons/facilities/categories/Entertainment'))
const Internet = dynamic(() => import('client/icons/facilities/categories/Internet'))
const Parking = dynamic(() => import('client/icons/facilities/categories/Parking'))
const Transportation = dynamic(() => import('client/icons/facilities/categories/Transportation'))
const Pool = dynamic(() => import('client/icons/facilities/categories/Pool'))
const Beach = dynamic(() => import('client/icons/facilities/categories/Beach'))
const Outdoors = dynamic(() => import('client/icons/facilities/categories/Outdoors'))
const GuestServices = dynamic(() => import('client/icons/facilities/categories/GuestServices'))
const Conveniences = dynamic(() => import('client/icons/facilities/categories/Conveniences'))
const Accessibility = dynamic(() => import('client/icons/facilities/categories/Accessibility'))
const FamilyFriendly = dynamic(() => import('client/icons/facilities/categories/FamilyFriendly'))
const Inclusivity = dynamic(() => import('client/icons/facilities/categories/Inclusivity'))
const Dining = dynamic(() => import('client/icons/facilities/categories/Dining'))
const FoodAndDrink = dynamic(() => import('client/icons/facilities/categories/FoodAndDrink'))
const BusinessServices = dynamic(
  () => import('client/icons/facilities/categories/BusinessServices')
)
const ThingsToDo = dynamic(() => import('client/icons/facilities/categories/ThingsToDo'))
const Wellness = dynamic(() => import('client/icons/facilities/categories/Wellness'))
const Spa = dynamic(() => import('client/icons/facilities/categories/Spa'))
const Others = dynamic(() => import('client/icons/facilities/categories/Others'))
const Safety = dynamic(() => import('client/icons/facilities/categories/Safety'))
const Payment = dynamic(() => import('client/icons/facilities/categories/Payment'))
const Certifications = dynamic(() => import('client/icons/facilities/categories/Certifications'))

const codeIcons = {
  [FacilityCategoriesTypes.TRANSPORTATION]: Transportation,
  [FacilityCategoriesTypes.ENTERTAINMENT]: Entertainment,
  [FacilityCategoriesTypes.INTERNET]: Internet,
  [FacilityCategoriesTypes.PARKING]: Parking,
  [FacilityCategoriesTypes.POOL]: Pool,
  [FacilityCategoriesTypes.BEACH]: Beach,
  [FacilityCategoriesTypes.OUTDOORS]: Outdoors,
  [FacilityCategoriesTypes.GUEST_SERVICES]: GuestServices,
  [FacilityCategoriesTypes.CONVENIENCES]: Conveniences,
  [FacilityCategoriesTypes.ACCESSIBILITY]: Accessibility,
  [FacilityCategoriesTypes.FAMILY_FRIENDLY]: FamilyFriendly,
  [FacilityCategoriesTypes.INCLUSIVITY]: Inclusivity,
  [FacilityCategoriesTypes.DINING]: Dining,
  [FacilityCategoriesTypes.FOOD_AND_DRINK]: FoodAndDrink,
  [FacilityCategoriesTypes.BUSINESS_SERVICES]: BusinessServices,
  [FacilityCategoriesTypes.THINGS_TO_DO]: ThingsToDo,
  [FacilityCategoriesTypes.WELLNESS]: Wellness,
  [FacilityCategoriesTypes.SPA]: Spa,
  [FacilityCategoriesTypes.OTHERS]: Others,
  [FacilityCategoriesTypes.SAFETY]: Safety,
  [FacilityCategoriesTypes.PAYMENT]: Payment,
  [FacilityCategoriesTypes.CERTIFICATIONS]: Certifications,
}

const CategoryIcon = ({ code }: { code: FacilityCategoriesTypes }) => {
  const Icon = codeIcons[code] || Others
  return <Icon />
}

export default CategoryIcon
